import { Fragment, PropsWithChildren, useEffect } from "react";

import { useCloudStatus } from "../../hooks";

/**
 * Timing component to set the percieved provisioning start timer.
 */
export const PerceivedProvisioningStartTimer = ({
    children
}: PropsWithChildren) => {
    const { startPerceivedProvisioningTimer } = useCloudStatus();

    useEffect(() => {
        startPerceivedProvisioningTimer();
    }, []);

    return <Fragment>{children}</Fragment>;
};
